import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import './style.css';
const propTypes = {
  url: PropTypes.string,
  icon: PropTypes.string.isRequired,
  count: PropTypes.number,
  i18nKey: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string,
  onClick: PropTypes.func,
};

export default function links({ url, icon, count, i18nKey, defaultMessage, onClick }) {
  return (
    <li className="link-item">
      <a
        className="link-item__link"
        href={url}
        onClick={e => {
          if (typeof onClick === 'function') {
            e.preventDefault();
            onClick();
          }
        }}
      >
        <div className="link-item__icon">
          <img src={icon} width="80px" height="80px"/>
          {
            count > 0 && (
              <span className="link-item__counter">{ count > 99 ? 'N' : count }</span>
            )
          }
        </div>
        <h6 className="link-item__title">
          <FormattedMessage id={i18nKey} defaultMessage={defaultMessage} />
        </h6>
      </a>
    </li>
  );
}

links.propTypes = propTypes;



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Tube/screens/Index/components/LinkItem/index.js
 **/